import { emptyError } from "../../Types/ServicesType/servicesType"
import api from "@services/apiList";
import instance from "@services/services";
const {reportsApi}=api 

export const expenseListReportService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.expenseReportSearch,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}
export const expenseListReportpdfService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.expenseReportSearchpdf,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}
export const expenseListReportExcelService = async (data:any): Promise<any> => {
    try {
        const result=await instance.post(reportsApi.expenseReportSearchexcel,data)
        return result.data
    } catch (error) {
        return emptyError
    }
}